<template>
  <div class="mt-1">
    <a-tooltip placement="top" title="View Workspace">
      <div class="quick_action_item" @click="handleViewAction">
        <img class="size-5" :src="imagePath.previewIcon" alt="view_icon" />
      </div>
    </a-tooltip>
  </div>
</template>

<script setup>
import imagePath from '@/javascript/imagePath';

const props = defineProps({
  row: { type: Object, required: true },
  action: { type: Object, required: true },
});

const emit = defineEmits(['action']);

const handleViewAction = () => {
  emit('action', {
    action: { id: 'view' },
    row: props.row,
  });
};
</script>
